import { put } from 'redux-saga/effects';
import { select } from 'typed-redux-saga';

import { getUserSocialBindsRequest } from './userSocialBinds.module';
import { handleUserSocialBindSuccess } from './userSocialBinds.saga';
import { UserSocialBindSelectors } from './userSocialBinds.selectors';

export function* loadUserSocialBindsIfNotLoaded() {
    const { isLoaded, isLoading } = yield* select(UserSocialBindSelectors.getLoadingState);

    if (!isLoaded && !isLoading) {
        yield put(getUserSocialBindsRequest());
    }

    return yield handleUserSocialBindSuccess();
}
